<template>
  <form-wrapper :validator="$v.items">

    <b-form-row>
      <b-col>
        <text-group
          :input-cols="5"
          :m="items"
          name="soc_zaplatene"
          :label="$t('message.soc_zaplatene')" />
        <text-group
          :input-cols="5"
          :m="items"
          name="soc_dobrovolne"
          :label="$t('message.soc_dobrovolne')" />
      </b-col>
      <b-col>
        <text-group
          :input-cols="5"
          :m="items"
          name="zdrav_zaplatene"
          :label="$t('message.zdrav_zaplatene')" />
        <text-group
          :input-cols="5"
          :m="items"
          name="zdrav_zdan_obdobie"
          :label="$t('message.zdrav_zdan_obdobie')" />
      </b-col>
    </b-form-row>

    <b-button
      class="btn-primary"
      @click="save">{{ $t('message.lblSave') }}</b-button>
  </form-wrapper>
</template>

<script>
import { minValue, maxValue, decimal } from 'vuelidate/lib/validators';
import restEditor from '@/mixins/restEditor';
import textGroup from '@/components/extractor/moneyTextGroup.vue';

export default {
  components: {
    textGroup,
  },

  mixins: [restEditor],
  data() {
    return {
      id: null,
      parent: this.$route.params.userId,
      items: {
        id: null,
        parent: null,
        soc_zaplatene: null,
        soc_dobrovolne: null,
        zdrav_zaplatene: null,
        zdrav_zdan_obdobie: null,
      },
    };
  },
  validations: {
    items: {
      soc_zaplatene: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      soc_dobrovolne: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      zdrav_zaplatene: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      zdrav_zdan_obdobie: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
    },
  },

  methods: {
    async processGet() {
      this.id = await this.restDataSource.getSposobId(this.parent, 6);
      if (this.id !== null) {
        this.items = await this.restDataSource.getData(this.id, 'par6poistne');
      }
    },
    async processSave() {
      if (this.id === null) {
        this.items.parent = this.parent;
        await this.restDataSource.createData(this.items, 'par6poistne');
      } else {
        await this.restDataSource.updateData(this.items, 'par6poistne');
      }
    },
  },

};
</script>

<style>
.form-row > .col, .form-row > [class*="col-"] {
    padding-right: 30px;
    padding-left: 0px;
}
.form-check-label {
    margin-bottom: 12px;
}
.form-check-inline .form-check-input {
    margin-top: -12px;
}
</style>

